import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginWithGoogle } = useAuth();

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      setLoading(true);
      await loginWithGoogle();
    } catch (err) {
      setError(err.message || 'Failed to sign in with Google.');
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <h1 className="login-title">georgekutti status</h1>
        <div className="login-form">
          {error && <div className="error-message">{error}</div>}
          <button 
            onClick={handleGoogleSignIn}
            className="google-signin-button"
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign in with Google'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
